export default __webpack_public_path__ + "static/media/operator-management.2f2e0792.svg";